import React, { useEffect } from 'react';
import tableImage from '../images/table.jpg';
import LysSeparator from './LysSeparator';
import {
  TextBlock,
  Container,
  TitleBlock,
  Image,
  Hours,
  Location,
  Days,
  Small,
} from './styles/HoursnLocation';

function HoursLocation() {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.src =
      'https://www.opentable.com/widget/reservation/loader?rid=54394&type=button&theme=standard&color=1&dark=false&iframe=true&domain=com&lang=en-US&newtab=false&ot_source=Restaurant%20website&cfe=true';
    script.async = true;

    // Add script to a specific div
    const widgetDiv = document.getElementById('opentable-widget');
    if (widgetDiv) {
      widgetDiv.appendChild(script);
    }

    // Cleanup
    return () => {
      if (widgetDiv && script.parentNode) {
        widgetDiv.removeChild(script);
      }
    };
  }, []);

  return (
    <Container>
      <Image>
        <img src={tableImage} alt="tableImage" />
      </Image>
      <TextBlock>
        <TitleBlock id="hours">
          <Hours>Hours</Hours>
          <Location location>{'& Location'}</Location>
        </TitleBlock>
        <Days>
          Lunch : Mon-Fri 11:30am - 3:00pm <br />
          Brunch : Sat, Sun 11:30am - 3:00pm
          <br />
          Dinner : Mon-Thu, Sun 3:00pm - 9:15 pm <br />
          Friday and Saturday 3:00pm - 9:45 pm
        </Days>
        <LysSeparator />
        <p>Located on :</p>
        <strong>75 West 68th Street</strong>
        <p>{'( Between Columbus Ave & Central Park West )'}</p>
        <p>Short walk to :</p>
        <p style={{ textAlign: 'center' }}>
          Lincoln Center, NYC Ballet, Metropolitan Opera House , Time Warner
          Center, AMC Loews Theater, ABC Studio , Central Park
        </p>
        <p style={{ textAlign: 'center' }}>
          <Small>For large party reservation please email us</Small>
        </p>

        {/* OpenTable Widget Container with isolation styles */}
        <div
          id="opentable-widget"
          style={{
            textAlign: 'center',
            marginTop: '20px',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '50px', // Prevent layout shift
            maxWidth: '100%',
            isolation: 'isolate', // Create a new stacking context
          }}
        />
      </TextBlock>
    </Container>
  );
}

export default HoursLocation;
